import type { Permission } from '../api/types';

// Formatierung für Auftragspreis und Preisliste (OFFENE_FRAGEN B-22).
const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const number = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

export const fmtCents = (cents: number) => euro.format(cents / 100);
export const fmtEuro = (value: number) => euro.format(value);
export const fmtNumber = (value: number) => number.format(value);

// Faktor aus Basispunkten: 8000 → „0,8“, 10000 → „1,0“, 9500 → „0,95“.
export const fmtFactor = (bp: number) =>
  (bp / 10000).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 2 });

export const tierLabels: Record<string, string> = { RURAL: 'Ländlich', NORMAL: 'Normal', URBAN: 'Großstadt und Speckgürtel' };

export const mandateKindLabels: Record<string, string> = { GENERAL: 'Allgemeiner Auftrag', QUALIFIED: 'Qualifizierter Alleinauftrag' };

// Heute als JJJJ-MM-TT (Ortszeit) für das Datum der Auftragserteilung.
export function todayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export const contractModelLabels: Record<string, string> = {
  OWN: 'Eigener Makler',
  ORDER_PRICE: 'Partner im Auftragspreis',
};

export const contractModelDescriptions: Record<string, string> = {
  OWN: 'Maklerplan führt das Maklergeschäft selbst – kein Auftragspreis.',
  ORDER_PRICE: 'Zahlt je erteiltem Auftrag aus unseren Terminen (Konzept 10), ohne Vorkasse und ohne Provisionsbeteiligung.',
};

// Leitung und Support sehen Preisliste und Vertragsmodell jedes Maklers (wie im Backend).
export const isOffice = (can: (p: Permission) => boolean) => can('project.manage') || can('ticket.manage') || can('call.review');

// Stand der Rechnung zu einem Auftrag (Rechnungsstellung, OFFENE_FRAGEN B-22).
export const invoiceStatusLabels: Record<string, string> = { DRAFT: 'Entwurf – noch nicht freigegeben', ISSUED: 'gestellt, offen', PAID: 'bezahlt', CANCELED: 'storniert' };
